import { format, isValid } from "date-fns";
import { de } from "date-fns/locale";
import React, { useEffect, useState } from "react";
import { ISperrmuel } from "../../api/spermuell/spermuell.api";
import {
  AdminCheckbox,
  AdminContentWrapper,
  AdminHeader,
  AdminPlaceholder,
  Loader,
  ModalWrapper,
  TableGrid,
  TableLastItem,
} from "../../components";
import { useAppDispatch, useAppSelector } from "../../store";
import {
  getAdminNotificationItemsCount,
  setIsConfirmationPopupActive,
} from "../../store/slices/app";
import {
  changeSperrmuellItemsStatuses,
  clearSperrmuelData,
  getSperrmuelDataSearch,
} from "../../store/slices/sperrmuell";
import Modal from "./components/Modal";
import {
  GridColumn,
  GridCellProps,
  GridHeaderCellProps,
} from "@progress/kendo-react-grid";
import { setDataLoading } from "../../store/slices/admin";
import { SortDescriptor } from "@progress/kendo-data-query";
import appConfig from "../../util/appConfig";
import API from "../../api/api";

export const statuses: { [key: string]: string } = {
  check: "Prüfen",
  accepted: "Fertig",
  declined: "Storniert",
  inWork: appConfig.logo === "calw" ? "Offen" : "In Arbeit",
  error: "Fehler",
};

const AdminSperrmuelanmeldungen = () => {
  const dispatch = useAppDispatch();
  const sperrmuelData = useAppSelector(
    (state) => state.sperrmuell.admin.sperrmuelData,
  );
  const isModalActive = useAppSelector(
    (state) => state.app.client.isConfirmationPopupActive,
  );

  const isAdminLoaderActive = useAppSelector(
    (state) => state.admin.isAdminLoaderActive,
  );
  const { sperrmuelDataTotalCount, isSperrmuelDataLoading } = useAppSelector(
    (state) => state.sperrmuell.admin,
  );
  const [selectedItem, setSelectedItem] = useState<null | ISperrmuel>(null);
  const [sort, setSort] = useState<Array<SortDescriptor>>([]);
  const [value, setValue] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [status, setStatus] = useState<string[]>(
    !["calw"].includes(appConfig.logo) ? ["check"] : [],
  );
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [datesChanged, setDatesChanged] = useState({});
  const [serviceType, setServiceType] = useState<string[]>([]);
  const [leistungsartType, setLeistungsartType] = useState<string[]>([]);
  const [selectedItems, setSelectedItems] = useState<string[]>([]);
  const [allItemsSelected, setAllItemsSelected] = useState(false);

  const onDateChange = (dates: [Date | null, Date | null]) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
    if (end || end === null) {
      setDatesChanged({ updated: true });
    }
  };

  const changeHandler = (val: string) => {
    setValue(val);
  };

  // const selectItemHandler = (id: string) => {
  //   const item = sperrmuelData.find((i) => i.id === id);
  //   setSelectedItem(item!);
  //   dispatch(setIsConfirmationPopupActive(true));
  // };

  const changeStatuses = (st: string[]) => {
    setStatus([...st]);
  };
  const changeSetServiceType = (st: string[]) => {
    setServiceType([...st]);
  };
  const changeSetLeistungsartType = (st: string[]) => {
    setLeistungsartType([...st]);
  };

  useEffect(() => {
    const abortController = new window.AbortController();
    const signal = abortController.signal;
    dispatch(
      getSperrmuelDataSearch({
        sort: sort.length && sort[0].field ? sort[0].field : "",
        direction: sort.length && sort[0].dir ? sort[0].dir : "",
        searchValue: value.length ? value : undefined,
        page: page,
        limit: pageSize,
        status: ["ebwo", "lra", "calw", "leverkusen"].includes(appConfig.logo)
          ? status.length
            ? [...status]
            : ["check", "accepted", "declined", "inWork"]
          : undefined,
        startDate: startDate ? new Date(startDate).toUTCString() : startDate,
        endDate: endDate ? new Date(endDate).toUTCString() : endDate,
        signal,
        serviceType,
        trashType: leistungsartType,
      }),
    );

    return () => {
      if (signal && abortController.abort) {
        abortController.abort();
      }
    };
  }, [
    sort,
    value,
    page,
    pageSize,
    status,
    datesChanged,
    serviceType,
    leistungsartType,
  ]);

  const generateSelectOptions = (type: string) => {
    switch (type) {
      case "lra": {
        return [
          { label: statuses.check, value: "check" },
          { label: statuses.accepted, value: "accepted" },
          { label: statuses.declined, value: "declined" },
          { label: statuses.inWork, value: "inWork" },
          { label: statuses.error, value: "error" },
        ];
      }
      case "leverkusen": {
        return [
          { label: statuses.check, value: "check" },
          { label: statuses.accepted, value: "accepted" },
          { label: statuses.declined, value: "declined" },
          { label: statuses.inWork, value: "inWork" },
          { label: statuses.error, value: "error" },
        ];
      }
      case "calw": {
        return [
          { label: statuses.accepted, value: "accepted" },
          { label: statuses.inWork, value: "inWork" },
          { label: statuses.declined, value: "declined" },
        ];
      }
      default: {
        return [
          { label: statuses.check, value: "check" },
          { label: statuses.accepted, value: "accepted" },
          { label: statuses.declined, value: "declined" },
          { label: statuses.inWork, value: "inWork" },
        ];
      }
    }
  };

  const generateServiceType = (type: string) => {
    switch (type) {
      case "calw": {
        return [
          { label: "Expressservice", value: "Expressservice" },
          { label: "Standardservice", value: "Standardservice" },
          // { label: "Selbstanlieferung", value: "Selbstanlieferung" },
        ];
      }
      default: {
        return [];
      }
    }
  };
  const generateLesitungsartType = (type: string) => {
    switch (type) {
      case "calw": {
        return [
          { label: "Sperrmüll", value: "Sperrmüll" },
          { label: "Altholz", value: "Altholz" },
        ];
      }
      default: {
        return [];
      }
    }
  };

  useEffect(() => {
    return () => {
      dispatch(clearSperrmuelData());
      dispatch(setDataLoading(false));
    };
  }, []);

  const pageChangeHandler = (page: number) => {
    setPage(page);
  };

  const pageSizeHandler = (size: number) => {
    setPage(1);
    setPageSize(size);
  };

  const setAcceptedStatus = async () => {
    // if (["calw"].includes(appConfig.logo)) {
    await dispatch(
      changeSperrmuellItemsStatuses({
        ids: selectedItems,
        status: "accepted",
      }),
    );
    await dispatch(getAdminNotificationItemsCount());
    return;
    // }
  };

  const downloadExcel = async () => {
    if (["calw"].includes(appConfig.logo)) {
      await setAcceptedStatus();
    }

    if (["lra", "leverkusen"].includes(appConfig.logo)) {
      await API.spermuell.get.downloadExcel({
        startDate: startDate ? new Date(startDate).toUTCString() : startDate,
        endDate: endDate ? new Date(endDate).toUTCString() : endDate,
        searchValue: value,
        serviceType,
        status,
      });
    }
    if (["awl"].includes(appConfig.logo)) {
      await API.spermuell.get.downloadExcel({
        startDate: null,
        endDate: null,
        searchValue: "",
        serviceType: [],
        status: [],
      });
    }
  };

  let items: any[] = [];

  if (["ebwo", "lra"].includes(appConfig.logo)) {
    items = [
      {
        field: "status",
        title: "Status",
      },
      {
        field: "createdAt",
        title: "Datum (Meldung)",
      },
      {
        field: "name",
        title: appConfig.logo === "calw" ? "Nachname, Vorname" : "Vorname Name",
      },
      {
        field: "streetData",
        title: "Strasse Hausnummer",
        width: "200px",
      },
      { field: "postcode", title: "PLZ" },
      {
        field: appConfig.logo === "calw" ? "serviceType" : "trashType",
        title: "Leistung",
        cell: (props: GridCellProps) => {
          if (appConfig.logo === "calw") {
            return (
              <td
                style={{
                  border: "none",
                  fontFamily: "Nunito",
                  fontWeight: "inherit",
                  fontSize: "16px",
                }}
                key={Math.floor(Math.random() * 1000000000000)}
              >
                {props.dataItem.serviceType}
              </td>
            );
          }
          return (
            <td
              style={{
                border: "none",
                fontFamily: "Nunito",
                fontWeight: "inherit",
                fontSize: "16px",
              }}
              key={Math.floor(Math.random() * 1000000000000)}
            >
              {props.dataItem.trashType.split(",").map((i: string) => {
                return (
                  <div key={Math.floor(Math.random() * 1000000000000)}>{i}</div>
                );
              })}
            </td>
          );
        },
      },
      {
        field: "trashTypeDates",
        title: "Leistungsdatum",
        cell: (props: GridCellProps) => {
          return (
            <td
              style={{
                border: "none",
                fontFamily: "Nunito",
                fontWeight: "inherit",
                fontSize: "16px",
              }}
              key={Math.floor(Math.random() * 1000000000000)}
            >
              {props.dataItem.trashTypeDates.split(",").map((i: string) => {
                return (
                  <div key={Math.floor(Math.random() * 1000000000000)}>{i}</div>
                );
              })}
            </td>
          );
        },
      },
    ];
  } else if (["calw"].includes(appConfig.logo)) {
    items = [
      {
        field: "status",
        title: "Status",
      },
      {
        field: "createdAt",
        title: "Datum (Meldung)",
      },
      // {
      //   field: "kassenzeichen",
      //   title: "Kassenzeichen",
      // },
      {
        field: "name",
        title: "Name, Vorname",
      },
      {
        field: "streetData",
        title: "Strasse",
        width: "200px",
      },
      { field: "postcode", title: "PLZ" },
      { field: "pickupPlace", title: "Ort" },
      { field: "trashTypeInfo", title: "Leistungsart" },
      {
        field: "serviceType",
        title: "Serviceart",
        cell: (props: GridCellProps) => {
          if (appConfig.logo === "calw") {
            return (
              <td
                style={{
                  border: "none",
                  fontFamily: "Nunito",
                  fontWeight: "inherit",
                  fontSize: "16px",
                }}
                key={Math.floor(Math.random() * 1000000000000)}
              >
                {props.dataItem.serviceType}
              </td>
            );
          }
          return (
            <td
              style={{
                border: "none",
                fontFamily: "Nunito",
                fontWeight: "inherit",
                fontSize: "16px",
              }}
              key={Math.floor(Math.random() * 1000000000000)}
            >
              {props.dataItem.trashType.split(",").map((i: string) => {
                return (
                  <div key={Math.floor(Math.random() * 1000000000000)}>{i}</div>
                );
              })}
            </td>
          );
        },
      },
      {
        field: "trashTypeDates",
        title: "Leistungsdatum",
        cell: (props: GridCellProps) => {
          return (
            <td
              style={{
                border: "none",
                fontFamily: "Nunito",
                fontWeight: "inherit",
                fontSize: "16px",
              }}
              key={Math.floor(Math.random() * 1000000000000)}
            >
              {props.dataItem.trashTypeDates.split(",").map((i: string) => {
                return (
                  <div key={Math.floor(Math.random() * 1000000000000)}>{i}</div>
                );
              })}
            </td>
          );
        },
      },
    ];
  } else {
    items = [
      {
        field: "createdAt",
        title: "Termin",
      },
      {
        field: "name",
        title: "Vorname Name",
      },
      {
        field: "streetData",
        title: "Strasse Hausnummer",
        width: "200px",
      },
      { field: "postcode", title: "PLZ" },
      {
        field: "trashType",
        title: "Leistung",
        cell: (props: GridCellProps) => {
          return (
            <td
              style={{
                border: "none",
                fontFamily: "Nunito",
                fontWeight: "inherit",
                fontSize: "16px",
              }}
              key={Math.floor(Math.random() * 1000000000000)}
            >
              {props.dataItem.trashType.split(",").map((i: string) => {
                return (
                  <div key={Math.floor(Math.random() * 1000000000000)}>{i}</div>
                );
              })}
            </td>
          );
        },
      },
      {
        field: "trashTypeDates",
        title: "Leistungsdatum",
        cell: (props: GridCellProps) => {
          return (
            <td
              style={{
                border: "none",
                fontFamily: "Nunito",
                fontWeight: "inherit",
                fontSize: "16px",
              }}
              key={Math.floor(Math.random() * 1000000000000)}
            >
              {props.dataItem.trashTypeDates.split(",").map((i: string) => {
                return (
                  <div key={Math.floor(Math.random() * 1000000000000)}>{i}</div>
                );
              })}
            </td>
          );
        },
      },
      {
        field: "isSynchronizedWithTicketSystem",
        title: "Synchronisiert",
      },
    ];
  }

  // if (["calw"].includes(appConfig.logo)) {
  //   items.push({
  //     field: "trashTypeInfo",
  //     title: "Leistungsart",
  //   });
  // }

  const allItemsSelectHandler = () => {
    if (!allItemsSelected) {
      setAllItemsSelected(true);
      const ids = sperrmuelData.map((i) => i.id);
      setSelectedItems([...ids]);
      return;
    }
    if (allItemsSelected) {
      setAllItemsSelected(false);
      setSelectedItems([]);
      return;
    }
  };

  const selectItemHandler = (id: string) => {
    if (selectedItems.includes(id)) {
      const t = selectedItems.filter((i) => i !== id);
      return setSelectedItems([...t]);
    }

    if (!selectedItems.includes(id)) {
      return setSelectedItems((prev) => [...prev, id]);
    }
  };

  const FirstItem = (props: GridCellProps) => {
    return (
      <td
        // className="k-command-cell"
        style={
          {
            // backgroundColor: 'white',
          }
        }
      >
        <AdminCheckbox
          checked={selectedItems.includes(props.dataItem.id)}
          changeHandler={() => {
            selectItemHandler(props.dataItem.id);
          }}
        />
      </td>
    );
  };
  const FirstHeaderItem = (props: GridHeaderCellProps) => {
    return (
      <div
        style={{
          margin: "0",
          padding: "0",
          position: "absolute",
          top: "50%",
          transform: "translateY(-50%)",
          // border: "none",
          // backgroundColor: "rgba(0, 0, 0, 0.02) !important",
        }}
        // className={style.qwe}
      >
        <AdminCheckbox
          checked={allItemsSelected}
          changeHandler={allItemsSelectHandler}
        />
      </div>
    );
  };

  const selectorOptions = [
    {
      placeholder: "Bitte Status wählen",
      isActive: ["ebwo", "lra", "calw", "leverkusen"].includes(appConfig.logo),
      defaultValue: { label: "Prüfen", value: status[0] },
      selectOptions: generateSelectOptions(appConfig.logo).filter(
        (el) => !status.includes(el.value),
      ),
      value: status.map((el) => {
        return {
          value: el,
          label: statuses[el],
        };
      }),
      onChange: changeStatuses,
    },
    {
      placeholder: "Bitte Servicetyp wählen",
      isActive: ["calw"].includes(appConfig.logo),
      defaultValue: undefined,
      selectOptions: generateServiceType(appConfig.logo).filter(
        (el) => !serviceType.includes(el.value),
      ),
      value: serviceType.map((el) => {
        return {
          value: el,
          label: el,
        };
      }),
      onChange: changeSetServiceType,
    },
    {
      placeholder: "Bitte Leistungsart wählen",
      isActive: ["calw"].includes(appConfig.logo),
      defaultValue: undefined,
      selectOptions: generateLesitungsartType(appConfig.logo).filter(
        (el) => !serviceType.includes(el.value),
      ),
      value: leistungsartType.map((el) => {
        return {
          value: el,
          label: el,
        };
      }),
      onChange: changeSetLeistungsartType,
    },
  ];

  return (
    <div
      style={{
        position: "relative",
      }}
    >
      <AdminHeader pageTitle={"Sperrmüllanmeldungen"} hasBtnGroup={false} />
      <AdminContentWrapper>
        {isSperrmuelDataLoading ? null : (
          // !sperrmuelData.length &&
          //     !["ebwo", "lra", "calw"].includes(appConfig.logo) ? (
          //     <AdminPlaceholder
          //       title="No Bulky Wastes Yet"
          //       subTitle="Some description placeholder"
          //       hasBtn={false}
          //     />
          //   ) :
          <TableGrid
            data={sperrmuelData.map((i) => {
              return {
                ...i,
                name:
                  appConfig.logo === "calw"
                    ? `${i.userSurname}, ${i.userName}`
                    : `${i.userName} ${i.userSurname}`,
                createdAt: i.createdAt
                  ? format(
                      new Date(i.createdAt),
                      appConfig.logo === "calw"
                        ? "dd.MM.yyyy, HH:mm"
                        : "dd. LLLL yyyy HH:mm:ss",
                      {
                        locale: de,
                      },
                    )
                  : "",
                trashType: i.pickUpTrash.reduce(
                  (prevItem: any, currItem: any) => {
                    prevItem = prevItem + `${currItem.trashType}, `;
                    return prevItem;
                  },
                  "",
                ),
                trashTypeDates: i.pickUpTrash.reduce(
                  (prevItem: any, currItem: any) => {
                    let value = "";
                    if (currItem.date === "Abfallberatung") {
                      value = "Abfallberatung";
                    }

                    if (currItem.date === "ExpressService") {
                      value = "Express Service";
                    }

                    if (currItem.date && isValid(new Date(currItem.date))) {
                      value = format(
                        new Date(currItem.date),
                        ["calw"].includes(appConfig.logo)
                          ? "dd.MM.yyyy"
                          : "dd. LLLL yyyy",
                        {
                          locale: de,
                        },
                      );
                    }
                    // const qwe =
                    //   currItem.date === "Abfallberatung"
                    //     ? "Abfallberatung"
                    //     : currItem.date === "ExpressService"
                    //     ? "Express Service"
                    //     : currItem.date
                    //     ? isValid(new Date(currItem.date))
                    //       ? format(new Date(currItem.date), "dd. LLLL yyyy", {
                    //           locale: de,
                    //         })
                    //       : ""
                    //     : "TBD";
                    prevItem = prevItem + `${value}, `;
                    return prevItem;
                  },
                  "",
                ),
                streetData: `${i.street} ${i.homeNumber ? i.homeNumber : ""}${
                  i.hausNrZusatz ? " " + i.hausNrZusatz : ""
                }${i.homeNumberTo ? ` - ${i.homeNumberTo}` : ""}`,
                status: i?.status ? statuses[i?.status] : statuses.check,
                trashTypeInfo: i?.trashType,
              };
            })}
            sort={sort}
            sortable={true}
            onSortChange={setSort}
            withExcelExport={["calw", "lra", "awl", "leverkusen"].includes(
              appConfig.logo,
            )}
            excelExportData={sperrmuelData
              .filter((el) => selectedItems.includes(el.id))
              .map((el) => {
                return {
                  Status: el?.status ? statuses[el?.status] : "",
                  "Datum (Meldung)": el?.createdAt
                    ? format(new Date(el?.createdAt), "dd.MM.yyyy, HH:mm", {
                        locale: de,
                      })
                    : "",
                  Kassenzeichen: `${
                    el?.buchungszeichen ? el?.buchungszeichen : ""
                  }`,
                  Name: `${el?.userSurname}, ${el?.userName}`,
                  Straße: `${el?.street} ${el?.homeNumber} ${
                    el?.hausNrZusatz ? " " + el?.hausNrZusatz : ""
                  } ${el?.homeNumberTo ? ` - ${el?.homeNumberTo}` : ""}`,
                  Ort: `${el?.postcode ? `${el.postcode}` : ""} ${
                    el?.pickupPlace ? `${el?.pickupPlace}` : ""
                  }`,
                  Telefonnummer: `${
                    el?.phoneNumber ? "+ " + el?.phoneNumber : ""
                  }`,
                  "E-Mail": `${el?.email}`,
                  Leistungsart: `${el?.trashType ? el?.trashType : ""}`,
                  Serviceart: `${
                    el?.isExpressService ? "Expressservice" : "Standardservice"
                  }`,
                  Leistungsdatum: `${
                    isValid(new Date(el?.pickUpTrash[0].date))
                      ? format(
                          new Date(el?.pickUpTrash[0].date),
                          "dd.MM.yyyy",
                          {
                            locale: de,
                          },
                        )
                      : !isValid(new Date(el?.pickUpTrash[0].date))
                        ? el?.pickUpTrash[0].date
                        : ""
                  }`,
                  Stückliste: el?.trashTypeData
                    ?.map((i) => {
                      return `${i.name} - ${i.value}`;
                    })
                    .toString()
                    .replaceAll(",", "; "),
                  Nachricht: `${el?.message ? el.message : ""}`,
                };
              })}
            // withPdfExport={true}
            items={items}
            excelExportItem={[
              {
                field: "Status",
                title: "Status",
              },
              {
                field: "Datum (Meldung)",
                title: "Datum (Meldung)",
              },
              // {
              //   field: "Kassenzeichen",
              //   title: "Kassenzeichen",
              // },
              {
                field: "Name",
                title: "Name",
              },
              {
                field: "Straße",
                title: "Straße",
              },
              {
                field: "Ort",
                title: "Ort",
              },
              {
                field: "Telefonnummer",
                title: "Telefonnummer",
              },
              {
                field: "E-Mail",
                title: "E-Mail",
              },
              {
                field: "Leistungsart",
                title: "Leistungsart",
              },
              {
                field: "Serviceart",
                title: "Serviceart",
              },
              {
                field: "Leistungsdatum",
                title: "Leistungsdatum",
              },
              {
                field: "Stückliste",
                title: "Stückliste",
              },
              {
                field: "Nachricht",
                title: "Nachricht",
              },
            ]}
            lastItem={<GridColumn cell={TableLastItem} width="50px" />}
            searchInputValue={value}
            onSearchInputValueChange={changeHandler}
            withPager={true}
            page={page}
            pageSize={pageSize}
            pageChangeHandler={pageChangeHandler}
            pageSizeHandler={pageSizeHandler}
            itemsCount={sperrmuelDataTotalCount}
            onExcelExportClickHandler={downloadExcel}
            onDateChange={onDateChange}
            startDate={startDate}
            endDate={endDate}
            withDatePicker={["calw", "lra", "leverkusen"].includes(
              appConfig.logo,
            )}
            selectorOptions={selectorOptions.filter((el) => el.isActive)}
            firstItem={
              ["calw"].includes(appConfig.logo) ? (
                <GridColumn
                  cell={FirstItem}
                  width="40px"
                  headerCell={FirstHeaderItem}
                />
              ) : null
            }
          />
          // <ContentComponent
          //   items={sperrmuelData}
          //   selectItemHandler={selectItemHandler}
          //   selectedItemId={selectedItem?.id || null}
          // />
        )}
      </AdminContentWrapper>
      {isModalActive && selectedItem ? (
        <ModalWrapper
          modalCloseHandler={() => {
            dispatch(setIsConfirmationPopupActive(false));
            setSelectedItem(null);
          }}
        >
          <Modal item={selectedItem} />
        </ModalWrapper>
      ) : null}
      {isAdminLoaderActive && <Loader />}
    </div>
  );
};

export default AdminSperrmuelanmeldungen;
